import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindAppsDownloadAndEngagementFilter from "../../../../models/AndroidDownloadAndEngagementFilter/AndroidDownloadAndEngagementFilter";
import DownloadEngagementFilterResult from "../DownloadEngagementFilterResult";

const AppAndroidDownloadEngagementFilterResult = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsDownloadAndEngagementFilter>): ReactElement | null => {
    return (
        <DownloadEngagementFilterResult
            filter={filter}
            value={value}
            hasDeviceFilter={false}
            onFilterUpdate={onFilterUpdate}
        />
    );
};

export default AppAndroidDownloadEngagementFilterResult;
